import { Box, Button, Typography } from "@mui/material";
import React from "react";
import CheckmarBadge from "../../../components/assets/checkmark-badge.svg";
import theme from "../../../theme";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../utils/constants/routes";
import { useTranslation } from "react-i18next";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  backgroundColor: theme.palette.background.paper,
  boxShadow: 24,
  borderRadius: 4,
  padding: theme.spacing(3),
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: theme.spacing(2),
};

export default function CarRelistedModal({ open, handleClose }) {
  const navigate = useNavigate();

  const { t } = useTranslation("myGarage");

  return (
    <Box sx={style}>
      {/* <ArticleOutlinedIcon
          sx={{ color: theme.palette.background.paper, fontSize: "36px" }}
        /> */}
      <img src={CheckmarBadge} alt="ss" />
      <Typography
        id="vehicle-added-modal-title"
        variant="h6"
        component="h2"
        sx={{
          color: theme.palette.text.primary,
          fontWeight: 600,
        }}
      >
        {t("Congratulations")}
      </Typography>
      <Typography
        id="vehicle-added-modal-description"
        sx={{
          color: theme.palette.text.disabled,
          textAlign: "center",
        }}
      >
        {t("Your car has been successfully relisted.")}
      </Typography>
      <Box display={"flex"} gap={2}>
        <Button
          onClick={() => {
            handleClose();
          }}
          variant="contained"
          sx={{
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.text.secondary,
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3),
            paddingTop: theme.spacing(1),
            paddingBottom: theme.spacing(1),
            textTransform: "none",
            "&:hover": {
              backgroundColor: theme.palette.primary.dark,
            },
          }}
        >
          {t("View My Car")}
        </Button>
        <Button
          onClick={() => {
            handleClose();
            navigate(routes.dashboardNavigation);
          }}
          variant="outlined"
          sx={{
            color: theme.palette.text.highlight,
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3),
            paddingTop: theme.spacing(1),
            paddingBottom: theme.spacing(1),
            textTransform: "none",
          }}
        >
          {t("My Garage")}
        </Button>
      </Box>
    </Box>
  );
}